import React, {useEffect, useState} from 'react';
import {loadStripe} from '@stripe/stripe-js';
import {Elements} from '@stripe/react-stripe-js';
import CardForm from './CardForm';

import {useGuide} from '../../../data/GuideProvider';

export default () => {
  const [promise, setPromise] = useState(null);
  const {keys} = useGuide();

  const publishableKey = keys ? keys.publishable : null;
  useEffect(() => {
    if (publishableKey) {
      setPromise(loadStripe(publishableKey));
    }
  }, [publishableKey]);

  if (!promise) {
    return null;
  }
  return (
    <Elements stripe={promise}>
      <CardForm />
    </Elements>
  );
};
